class SaturdayShiftFront {
  constructor({
    saturdayShiftId = null,
    note = null,
    description = null,
    simpleRule = null,
    specialRule = null,
    value = null,
    isnew = false,
  }) {
    this.saturdayShiftId = saturdayShiftId;
    this.note = note;
    this.description = description;
    this.simpleRule = simpleRule;
    this.specialRule = specialRule;
    this.value = value;
    this.isnew = isnew;
  }
}

class SaturdayShiftBack {
  constructor({
    saturdayShiftId = null,
    companyId = false,
    note = null,
    description = null,
    simpleRule = null,
    specialRule = null,
    value = null,
  }) {
    this.saturdayShiftId = saturdayShiftId;
    this.note = note;
    this.companyId = companyId;
    this.description = description;
    this.simpleRule = simpleRule;
    this.specialRule = specialRule;
    this.value = value;
  }
}

export { SaturdayShiftBack, SaturdayShiftFront };
